import { forwardRef, useState } from 'react';

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// Custom styles for MDInput
import MDInputRoot from 'components/MDInput/MDInputRoot';

const MDInput = forwardRef(
  (
    { error = false, success = false, disabled = false, InputLabelProps, InputProps, ...rest },
    ref
  ) => {
    const [hasValue, setHasValue] = useState(false);

    const onAnimationStartHandler = (stateSetter) => (e) => {
      const autofilled = !!e.target?.matches('*:-webkit-autofill');
      if (e.animationName === 'mui-auto-fill') {
        stateSetter(autofilled);
      }
      if (e.animationName === 'mui-auto-fill-cancel') {
        stateSetter(autofilled);
      }
    };

    let finalInputLabelProps = {};
    if (InputLabelProps || hasValue) {
      finalInputLabelProps = {
        ...InputLabelProps,
        shrink: InputLabelProps?.shrink || hasValue
      };
    }
    return (
      <MDInputRoot
        {...rest}
        ref={ref}
        ownerState={{ error, success, disabled }}
        InputLabelProps={finalInputLabelProps}
        InputProps={{
          ...InputProps,
          onAnimationStart: onAnimationStartHandler(setHasValue)
        }}
      />
    );
  }
);

// Typechecking props for the MDInput
MDInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  InputLabelProps: PropTypes.shape({ shrink: PropTypes.bool }),
  InputProps: PropTypes.object
};

export default MDInput;
